import { render, staticRenderFns } from "./DemoFormLayoutMultipleColumn.vue?vue&type=template&id=62e5808f"
import script from "./DemoFormLayoutMultipleColumn.vue?vue&type=script&lang=js"
export * from "./DemoFormLayoutMultipleColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports